export default {
  namespaced: true,
  
  state: () => ({
    visible: false,
    title: '',
    message: '',
    options: [],
    size: 'md',
    type: 'confirmation',
    events: {
      confirm: () => {},
    },
    data: null
  }),

  mutations: {
    change(state, data){
      if (data.title !== undefined) state.title = data.title;
      if (data.message !== undefined) state.message = data.message;
      if (data.options !== undefined) state.options = data.options;
      if (data.visible !== undefined) state.visible = data.visible;
      if (data.size !== undefined) state.size = data.size;
      if (data.type !== undefined) state.type = data.type;
      if (data.events !== undefined) {
        state.events.confirm = data.events.confirm || (() => {});
      }
    }
  },

  actions: {
    open({commit}, data){
      commit('change', {...data, visible: true});
    },

    close({commit}){
      commit('change', {visible: false});
    }
  }
};
